import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Llamada final a la acción" data-id="element-93">
      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-94">
        <FadeIn data-id="element-95">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-96">
            Última oportunidad —{' '}
            <span className="text-gold" data-id="element-97">elegí tu pack</span>
          </h2>
          <p className="text-gray-400 mb-10" data-id="element-98">
            🛡️ Garantía 7 días · ⚡ Acceso de inmediato · 🔒 Pago seguro
          </p>
        </FadeIn>

        {/* Pack 1 — Base */}
        <FadeIn delay={0.1} data-id="element-99">
          <a href="https://fegion.shop/cart/46850728263819:1" className="flex flex-col sm:flex-row items-center sm:items-stretch justify-between gap-4 p-5 md:p-6 bg-surfaceLight border border-white/10 rounded-2xl hover:border-white/30 transition-colors text-left mb-5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar El Maestro de las Mamparas — Sistema Completo por $19.990 ARS" data-id="element-100">
            <div className="flex-1" data-id="element-101">
              <span className="block text-base md:text-lg font-bold text-white mb-1" data-id="element-102">
                📘 EL MAESTRO DE LAS MAMPARAS — SISTEMA COMPLETO
              </span>
              <span className="block text-xs md:text-sm text-gray-400" data-id="element-103">
                8 Módulos + 3 Bonos
              </span>
            </div>
            <div className="flex items-center gap-4 shrink-0" data-id="element-104">
              <div className="flex flex-col items-end" data-id="element-105">
                <span aria-hidden="true" className="text-gray-500 line-through text-xs" data-id="element-106">
                  $45.000
                </span>
                <span className="text-xl md:text-2xl font-bold text-white" data-id="element-107">
                  $19.990
                </span>
              </div>
              <div className="py-2.5 px-4 rounded-xl font-bold text-white border border-white/20 uppercase tracking-wider text-[11px] whitespace-nowrap" data-id="element-108">
                Lo quiero
              </div>
            </div>
          </a>
        </FadeIn>

        {/* Pack 2 — Pro (dominant) */}
        <FadeIn delay={0.2} data-id="element-109">
          <div className="relative my-6" data-id="element-110">
            <div className="absolute -inset-1 rounded-3xl opacity-60 blur-md pointer-events-none" aria-hidden="true" style={{
            background: 'linear-gradient(135deg, rgba(245,200,66,0.6) 0%, rgba(212,168,67,0.4) 100%)'
          }} data-id="element-111"></div>
            <a href="https://fegion.shop/cart/46934190555275:1" className="relative flex flex-col md:flex-row items-center md:items-stretch justify-between gap-5 p-7 md:p-8 bg-gold rounded-3xl hover:bg-gold/90 transition-colors shadow-[0_0_35px_rgba(245,200,66,0.25)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar Pack Maestro Pro — Todo Incluido por $29.990 ARS" data-id="element-112">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-background text-gold border border-gold/40 font-bold px-5 py-1.5 rounded-full text-[11px] uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-113">
                ⭐ El más elegido
              </span>

              <div className="flex-1 text-left md:pr-4 flex flex-col justify-center mt-3 md:mt-0" data-id="element-114">
                <span className="block text-lg md:text-xl font-bold text-background mb-1" data-id="element-115">
                  🏆 PACK MAESTRO PRO — TODO INCLUIDO
                </span>
                <span className="block text-sm text-background/90 mb-1" data-id="element-116">
                  8 Módulos + 3 Bonos + Pack Maestro Pro + 7 Planillas Pro
                </span>
                <span className="block text-xs text-background/70" data-id="element-117">
                  Para talleres que quieren calcular, presupuestar y gestionar
                  sin errores
                </span>
              </div>

              <div className="flex flex-col items-center md:items-end justify-center shrink-0" data-id="element-118">
                <span aria-hidden="true" className="text-background/60 line-through text-sm" data-id="element-119">
                  $57.000 ARS
                </span>
                <span className="text-4xl md:text-5xl font-bold text-background font-heading leading-none" data-id="element-120">
                  $29.990
                </span>
                <span className="text-xs text-background/80 mt-1" data-id="element-121">ARS</span>
              </div>

              <div className="hidden md:flex items-center shrink-0" data-id="element-122">
                <div className="py-4 px-6 rounded-xl font-bold text-gold bg-background hover:bg-background/90 transition-colors uppercase tracking-wider text-sm text-center whitespace-nowrap" data-id="element-123">
                  → Quiero el Pro
                </div>
              </div>
              <div className="w-full md:hidden mt-2" data-id="element-124">
                <div className="w-full py-3 px-4 rounded-xl font-bold text-gold bg-background hover:bg-background/90 transition-colors uppercase tracking-wider text-xs text-center" data-id="element-125">
                  → Quiero el Pack Maestro Pro completo
                </div>
              </div>
            </a>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-126">
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-gray-400 mt-8" data-id="element-127">
            <div className="flex items-center gap-2" data-id="element-128">
              <span className="text-emerald-400" aria-hidden="true" data-id="element-129">
                🛡️
              </span>
              <span data-id="element-130">Garantía 7 días</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-131">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-132">
              <span className="text-emerald-400" aria-hidden="true" data-id="element-133">
                ⚡
              </span>
              <span data-id="element-134">Acceso de inmediato</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-135">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-136">
              <span className="text-emerald-400" aria-hidden="true" data-id="element-137">
                🔒
              </span>
              <span data-id="element-138">Pago 100% seguro</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-139">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-140">
              <span className="text-emerald-400" aria-hidden="true" data-id="element-141">
                💳
              </span>
              <span data-id="element-142">Mercado Pago | Tarjeta | Transferencia</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}